import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const BLOB_UPLOAD_FAILED_MESSAGE =
  'Não foi possível enviar o arquivo para o storage. Verifique a configuração CORS do Azure Blob Storage (métodos PUT, GET, HEAD e OPTIONS para a origem deste portal).';

const BLOB_AUTH_CONFLICT_MESSAGE =
  'O upload para o storage falhou porque o token de login foi enviado junto com a URL SAS. Tente novamente após atualizar a página.';

/** Cliente HTTP sem interceptors — evita Authorization Bearer no Blob Storage. */
function blobHttpClient(backend: HttpBackend): HttpClient {
  return new HttpClient(backend);
}

/** PUT direto no blob via SAS; confirma existência quando o browser bloqueia a resposta (CORS). */
export function putFileToBlobUrl(httpBackend: HttpBackend, uploadUrl: string, file: File): Observable<void> {
  const http = blobHttpClient(httpBackend);
  const headers = new HttpHeaders({
    'x-ms-blob-type': 'BlockBlob',
    'Content-Type': file.type || 'application/octet-stream',
  });

  return http.put(uploadUrl, file, { headers, responseType: 'text' }).pipe(
    map(() => void 0),
    catchError(err => {
      if (isBlobAuthHeaderConflict(err)) {
        return throwError(() => new Error(BLOB_AUTH_CONFLICT_MESSAGE));
      }
      return err?.status === 0 ? verifyBlobExists(http, uploadUrl) : throwError(() => err);
    }),
  );
}

function verifyBlobExists(http: HttpClient, blobUrl: string): Observable<void> {
  return http.head(blobUrl, { observe: 'response' }).pipe(
    map(res => {
      if (res.status >= 200 && res.status < 300) return void 0;
      throw new Error(BLOB_UPLOAD_FAILED_MESSAGE);
    }),
    catchError(err => {
      if (isBlobAuthHeaderConflict(err)) {
        return throwError(() => new Error(BLOB_AUTH_CONFLICT_MESSAGE));
      }
      return throwError(() => new Error(BLOB_UPLOAD_FAILED_MESSAGE));
    }),
  );
}

function isBlobAuthHeaderConflict(err: unknown): boolean {
  const status = (err as { status?: number })?.status;
  if (status !== 400) return false;
  const body = String((err as { error?: unknown })?.error ?? (err as { message?: string })?.message ?? '');
  return body.includes('Authorization') || body.includes('Authentication information');
}
